<template>
  <div class="setting">
    <van-nav-bar
      title="修改密码"
      left-text=""
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div class="cell-group">
      <van-form @submit="onSubmit">
        <van-field
          v-model="oldPassword"
          :type="passtype"
          name="oldPassword"
          placeholder="请输入旧密码"
          maxlength="13"
          style="margin-bottom: 24px"
        >
          <template #button>
            <img
              :src="imgFlag ? colseImg : openImg"
              class="filedimg"
              @click="checkImg"
            />
          </template>
        </van-field>
        <van-field
          v-model="password"
          :type="newpasstype"
          name="password"
          placeholder="请设置新密码"
          maxlength="13"
          style="margin-bottom: 24px"
        >
          <template #button>
            <img
              :src="newimgFlag ? colseImg : openImg"
              class="filedimg"
              @click="newcheckImg"
            />
          </template>
        </van-field>
        <van-field
          v-model="confirmPassword"
          :type="confirmpasstype"
          name="confirmPassword"
          placeholder="请确认新密码"
          maxlength="13"
          @blur="checkedConfirmPassword"
        >
          <template #button>
            <img
              :src="confirmimgFlag ? colseImg : openImg"
              class="filedimg"
              @click="confirmcheckImg"
            />
          </template>
        </van-field>
        <div class="setting_logout">
          <van-button round block type="info" native-type="submit" class="btn">
            确定
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { _modifyPassword } from "../../api/setting";
import { encryptBy, decryptBy } from "../../assets/js/encryption";
import { verticalScreen } from "../../assets/js/vertical-screen";
import {
  validateMobile,
  validatePassword,
  validatePassword1,
} from "../../common/validate";
export default {
  name: "change-password",
  data() {
    return {
      passtype: "password", // 密码框状态
      newpasstype: "password", // 密码框状态
      confirmpasstype: "password", // 密码框状态
      imgFlag: true, // 是否为密码框
      newimgFlag: true, // 是否为密码框
      confirmimgFlag: true, // 是否为密码框
      oldPassword: "", // 旧密码
      password: "", // 密码
      confirmPassword: "", // 确认密码
      // colseImg:require('../../assets/images/login/closeicon.png'),// 密码框不可查看
      // openImg:require('../../assets/images/login/openicon.png'),// 密码框可查看
      colseImg: require("../../assets/images/login/closeicon.png"), // 密码框不可查看
      openImg: require("../../assets/images/login/openicon.png"), // 密码框可查看
    };
  },
  mounted() {
    verticalScreen();
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    //切换密码
    checkImg() {
      this.imgFlag = !this.imgFlag;
      this.passtype = this.imgFlag ? "password" : "text";
    },
    //新密码切换密码
    newcheckImg() {
      this.newimgFlag = !this.newimgFlag;
      this.newpasstype = this.newimgFlag ? "password" : "text";
    },
    //确认密码切换密码
    confirmcheckImg() {
      this.confirmimgFlag = !this.confirmimgFlag;
      this.confirmpasstype = this.confirmimgFlag ? "password" : "text";
    },
    //校验确认密码
    checkedConfirmPassword() {
      if (this.confirmPassword !== this.password) {
        this.$toast("两次密码输入不一致，请重新输入");
        return false;
      }
    },
    //修改密码
    onSubmit() {
      if (!validatePassword1(this.password)) {
        this.$toast("至少6位数字/英文/数字+英文");
        return false;
      }
      _modifyPassword({
        origin: "C",
        confirmPassword: encryptBy(this.confirmPassword),
        newPassword: encryptBy(this.password),
        oldPassword: encryptBy(this.oldPassword),
      }).then((res) => {
        if (res.code == 200) {
          this.$toast("修改成功，请重新登录");
          Cookies.remove("token");
          localStorage.removeItem("childId");
          localStorage.removeItem("children");
          this.$router.push("/login");
        } else {
          this.$toast(res.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.setting {
  position: relative;
  .cell-group {
    padding: 20px 30px;
    background: url(../../assets/images/setting/bg.png) no-repeat left top/100%
      208px;
  }
  .filedimg {
    width: 22px;
    // width:18px;
    // height: 8px;
    //  margin-top: 7px;
  }
  .setting_logout {
    margin-top: 35px;
    text-align: center;
    /deep/.van-button--info {
      margin: 0 auto;
      width: 315px;
      height: 44px;
      background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
      border-radius: 22px;
      border-radius: 23px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
      line-height: 44px;
      // margin-left: 54.5px;
      border: none;
    }
  }
  ::v-deep .van-icon {
    color: #000;
  }
}
</style>
